<template>
  <div>
    <h1 class="display-3">Sponsorzy</h1><br/>
    <b-row>
      <b-col md="6">
        <p>
          Niezwykle ciekawa i wartościowa kolekcja osobista Janusza Bohdanowicza, która stanowi zapis historii Brygad AK Okręgu Wileńskiego
          (m.in. 3. Brygady „Szczerbca”, 6. Wileńskiej Samodzielnej Brygady Partyzanckiej AK oraz 7. Wileńskiej Brygady AK Okręgu Wileńskiego),
          została zdigitalizowana i jest już dostępna w Bibliotece Cyfrowej Ośrodka KARTA (AW III/618). Prezentowane dokumenty dotyczą przebiegu
          służby żołnierzy Brygad Armii Krajowej Okręgu Wileńskiego.
        </p>
      </b-col>

      <b-col md="3" cols="12">
        <b-img width="200px" center src="/sponsorzy/sponsorzy_logo.jpg" center fluid/>
      </b-col>
    </b-row>

    <p>
      Twórca kolekcji – śp. Janusz Bohdanowicz (zm. 5 lipca 2013) - od końca lat 80. aktywnie uczestniczył w tworzeniu się organizacji
      kombatanckich weteranów AK. Został przewodniczącym Środowiska Żołnierzy 7. Brygady „Wilhelma”, następnie prezesem Środowiska
      Wileńskiego Światowego Związku Żołnierzy Armii Krajowej (ŚZŻAK) w Gdańsku, a następnie w Warszawie, członkiem Komisji Historycznej
      Okręgu Wileńskiego, członkiem Rady Naczelnej i Prezydium Zarządu Głównego ŚZŻAK, przewodniczącym Komisji Współpracy z Młodzieżą Szkolną.
      Od 18 kwietnia 2011 do 20 września 2012 był prezesem Okręgu Wileńskiego ŚZŻAK. Ostatnie lata swego życia poświęcił gromadzeniu materiałów,
       ich cyfryzacji oraz tworzeniu strony internetowej - AKWilno.pl.
    </p>

    <p>
      Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w
      Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane
      przez Urząd do Spraw Kombatantów i Osób Represjonowanych.
    </p>
  </div>
</template>

<script>
export default {
  name: 'sponsorzy',
  metaInfo:{
    title: 'Sponsorzy',
    meta:[
      {name: 'description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' },
      {name: 'og:url', content: 'http://akwilno.pl/sponsorzy' },
      {name: 'og:title', content: 'Sponsorzy' },
      {name: 'og:image', content: '/sponsorzy/sponsorzy_logo.jpg' },
      {name: 'og:description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' },
      {name: 'twitter:url', content: 'http://akwilno.pl/sponsorzy' },
      {name: 'twitter:title', content: 'Sponsorzy' },
      {name: 'witter:image', content: '/sponsorzy/sponsorzy_logo.jpg' },
      {name: 'twitter:description', content: 'Digitalizacja i udostępnienie w Bibliotece Cyfrowej Ośrodka KARTA oraz na stronie internetowej AKWilno.pl przechowywanej w Archiwum Ośrodka KARTA kolekcji osobistej Janusza Bohdanowicza, a także przebudowa strony internetowej zostały sfinansowane przez Urząd do Spraw Kombatantów i Osób Represjonowanych.' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sponsorzy.vue